/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import DateTimePicker from 'react-datetime';
import NumberPicker from "react-widgets/NumberPicker";
import ToggleControl from 'app/components/common/ToggleControl.jsx';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import * as _ from 'underscore';

class PostScheduler extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            repeat: false,
            repeatCount: 1,
            repeatFrequency: 'days',
            scheduledDate: null,
            endDate: null,
            errors: []
        };

        this.schedulePost = this.schedulePost.bind(this);
        this.validateDates = this.validateDates.bind(this);

    }

    componentDidMount() {
        let defaultDate = new moment().add(1, 'days');

        if (['edit-queue', 'edit-everqueue'].indexOf(this.props.editMode) !== -1 && this.props.postData.services !== undefined) {
            Object.keys(this.props.postData.services).map((key) => {
                if (this.props.postData.services[key].post_ts !== undefined) {
                    defaultDate = new moment(this.props.postData.services[key].post_ts);
                }
            });
        } else if (this.props.postData.params.post_times.length) {
            let jsTime = parseInt(this.props.postData.params.post_times[0]) * 1000;
            defaultDate = new moment(jsTime);
        }

        this.setState({
            scheduledDate: defaultDate
        });

    }

    schedulePost() {
        let times = [this.state.scheduledDate.format("X")],
            repeatDate = this.state.scheduledDate;

        if (!this.validateDates()) {
            return;
        }

        if (this.state.repeat) {
            repeatDate = repeatDate.add(this.state.repeatCount, this.state.repeatFrequency);
            while (repeatDate < this.state.endDate) {
                times.push(repeatDate.format("X"));
                repeatDate = repeatDate.add(this.state.repeatCount, this.state.repeatFrequency);
            }
        }

        this.props.confirmAction(times);

    }

    validateDates() {
        let nextErrors = [],
            now = new Date().getTime();

        if (!moment.isMoment(this.state.scheduledDate)) {
            nextErrors.push({scheduledDate: 'Please select a date and time for when we should make your post.'});
        } else if (moment.isMoment(this.state.scheduledDate) && this.state.scheduledDate.format("x") < now) {
            nextErrors.push({scheduledDate: 'Please schedule your post for a time in the future.'});
        }

        if (this.state.repeat) {
            if (!moment.isMoment(this.state.endDate)) {
                nextErrors.push({endDate: 'Please choose a date when we should stop repeating this post.'});
            } else if (moment.isMoment(this.state.endDate) && this.state.endDate.format("x") < now) {
                nextErrors.push({endDate: "Please choose a date in the future for your post repeats to end."});
            }
        }

        if (!_.isEqual(nextErrors, this.state.errors)) {
            this.setState({
                errors: nextErrors
            });
        }

        if (nextErrors.length) {
            return false;
        }

        return true;

    }

    render() {
        let freqOptions = [
                {value: 'days', label: (this.state.repeatCount === 1) ? 'Day' : 'Days'},
                {value: 'weeks', label: (this.state.repeatCount === 1) ? 'Week' : 'Weeks'},
                {value: 'months', label: (this.state.repeatCount === 1) ? 'Month' : 'Months'}
            ],
            disabled = (this.state.repeat) ? false : true;

        const updateDate = (date, field, isTime) => {
            let nextState = Object.assign({}, this.state),
                nextDate = new moment().tz(this.props.user.detail.timezone);

            if (moment.isMoment(nextState[field])) {
                nextDate = new moment(nextState[field]).tz(this.props.user.detail.timezone);
            }

            if (moment.isMoment(date)) {
                if (isTime) {
                    nextDate.minutes(date.minutes());
                    nextDate.hours(date.hours());
                } else {
                    nextDate.month(date.month());
                    nextDate.date(date.date());
                    nextDate.year(date.year());
                }

                nextState[field] = nextDate;

                this.setState(nextState);
            }
        };

        const hasError = (field) => {
            let hasError = false;

            this.state.errors.map((error) => {
                if (error[field] !== undefined) {
                    hasError = true;
                }
            });

            return hasError;
        };

        let frequencyControls = null;
        if (this.state.repeat) {
            frequencyControls = (
                <div>
                    <div className="frequency-controls">
                        <fieldset>
                            <legend>Publish every</legend>
                            <NumberPicker
                                containerClassName="repeat-freq"
                                value={this.state.repeatCount}
                                min={1}
                                onChange={(value) => {
                                    this.setState({
                                        repeatCount: value
                                    });
                                }}
                                disabled={disabled}/>
                                <StyledSelect
                                    controlState={disabled ? 'disabled' : ''}
                                    value={this.state.repeatFrequency}
                                    onChange={(e) => {
                                        let nextValue = e.currentTarget.value;

                                        this.setState({
                                            repeatFrequency: nextValue
                                        });
                                    }}
                                    options={freqOptions}
                                    selectClass="med pt"/>
                        </fieldset>
                    </div>
                    <div className="end-date-controls">
                        <fieldset>
                            <legend>End date</legend>
                            <DateTimePicker
                                inputProps={{
                                    placeholder: "End Date",
                                    className: `text-input ${hasError('endDate') ? 'error' : ''}`,
                                    disabled: disabled
                                }}
                                timeFormat={false}
                                onChange={(newTime) => {
                                    updateDate(newTime, 'endDate', false);
                                }}
                                closeOnSelect={true}
                                value={this.state.endDate}
                                displayTimeZone={this.props.user.detail.timezone}/>
                            <DateTimePicker
                                inputProps={{
                                    placeholder:"End Time",
                                    className: `text-input ${hasError('endDate') ? 'error' : ''}`,
                                    disabled: disabled
                                }}
                                dateFormat={false}
                                onChange={(newTime) => {
                                    updateDate(newTime, 'endDate', true);
                                }}
                                closeOnSelect={true}
                                value={this.state.endDate}
                                displayTimeZone={this.props.user.detail.timezone}/>
                        </fieldset>
                    </div>
                </div>
            );
        }

        return (
            <div>
                <div className="pt-accessory-header">Schedule</div>
                <div className="pt-scheduler">
                    <div className="date-pickers">
                        <DateTimePicker
                            inputProps={{
                                placeholder: "Schedule Date",
                                className: `text-input ${hasError('scheduledDate') ? 'error' : ''}`
                            }}
                            timeFormat={false}
                            onChange={(newTime) => {
                                updateDate(newTime, 'scheduledDate', false);
                            }}
                            closeOnSelect={true}
                            value={this.state.scheduledDate}
                            displayTimeZone={this.props.user.detail.timezone}/>
                        <DateTimePicker
                            inputProps={{
                                placeholder:"Schedule Time",
                                className: `text-input ${hasError('scheduledDate') ? 'error' : ''}`
                            }}
                            dateFormat={false}
                            onChange={(newTime) => {
                                updateDate(newTime, 'scheduledDate', true);
                            }}
                            closeOnSelect={true}
                            value={this.state.scheduledDate}
                            displayTimeZone={this.props.user.detail.timezone}/>
                    </div>
                    {(['edit-queue', 'edit-everqueue'].indexOf(this.props.editMode) === -1) ? (
                        <div className="repeat-controls">
                            <ToggleControl
                                activeLabel="Repeat"
                                inactiveLabel="Repeat"
                                active={this.state.repeat}
                                callback={(e) => {
                                    let active = e.currentTarget.dataset.togglestate,
                                        nextRepeat = true;

                                    // // If twitter is selected, don't let the repeat option turn on
                                    // if (Object.keys(this.props.postData.services).indexOf("1") !== -1) {
                                    //     return;
                                    // }

                                    if (active === 'true') {
                                        nextRepeat = false
                                    }

                                    this.setState({
                                        repeat: nextRepeat
                                    });
                                }}/>
                            {frequencyControls}
                        </div>
                    ) : null}
                    {this.state.errors.length ? (
                        <ul className="pt-service-errors">
                            {this.state.errors.map((error) => {
                                let key = Object.keys(error);
                                return (
                                    <li key={`error-schedule-${key}`} className="post-error">
                                        <i className="icon ion-android-alert"></i>{error[key]}
                                    </li>
                                );
                            })}
                        </ul>
                    ) : null}
                </div>
                <div className="pt-accessory-actions">
                    <div role="button" aria-label="cancel delete" className="action-cancel" onClick={this.props.cancelAction}>
                        Go Back
                    </div>
                    <button type="button" className="btn-delete action-delete" onClick={this.schedulePost}>
                        Schedule
                    </button>
                </div>
            </div>
        );
    }
}

PostScheduler.displayName = "PostScheduler";

export default PostScheduler;
